import { createAction, props } from '@ngrx/store';

export const keepAlive = createAction(
  '[Kiosk] Keep alive',
  props<{ kioskId: number }>()
);

export const keepAliveSuccess = createAction(
  '[Kiosk] Keep alive success'
);

export const keepAliveFailure = createAction(
  '[Kiosk] Keep alive failure',
  props<{ error: any }>()
);

export const loadSysparams = createAction(
  '[Kiosk] Load sys params'
);

export const loadSysparamsSuccess = createAction(
  '[Kiosk] Load sys params success',
);

export const loadSysparamsFailure = createAction(
  '[Kiosk] Load sys params failure',
  props<{ error: any }>()
);
export const setWebSiteStarted = createAction("[TransactionInfo] Set website started", props<{ data: boolean }>());

export const setStopProcessInterval = createAction("[Kiosk] Set stop process interval", props<{ data: number }>());
export const setCardIdMaxAttempt = createAction("[Kiosk] Set card id max attempt", props<{ data: number }>());
export const setHomeS4AddChecksum = createAction("[Kiosk] Set homeS4addchecksum", props<{ data: boolean }>());
export const setMaxNbSendMailMedicalForm = createAction("[Kiosk] Set nb max mail send medical form", props<{ data: number }>());
export const setPrintLightEnabled = createAction("[Kiosk] Set print light enabled", props<{ data: boolean }>());